export enum AuthActionType {
  INIT_LOGIN = 'AUTH/INIT_LOGIN',
  INIT_CHECK_COMPLETED = 'AUTH/INIT_CHECK_COMPLETED',
  SEND_LOGIN = 'AUTH/SEND_LOGIN',
  SENDING_LOGIN = 'AUTH/SENDING_LOGIN',
  LOGIN_SUCCESS = 'AUTH/LOGIN_SUCCESS',
  LOGIN_ERROR = 'AUTH/LOGIN_ERROR',
  LOGIN_TWO_FACTOR_REQUIRED = 'AUTH/LOGIN_TWO_FACTOR_REQUIRED',
  SEND_TWO_FACTOR_VERIFY = 'AUTH/SEND_TWO_FACTOR_VERIFY',
  TWO_FACTOR_VERIFY_ERROR = 'AUTH/TWO_FACTOR_VERIFY_ERROR',
  REFRESH_TOKEN = 'AUTH/REFRESH_TOKEN',
  TOKEN_CHECKED = 'AUTH/TOKEN_CHECKED',
  REFRESH_TOKEN_ERROR = 'AUTH/REFRESH_TOKEN_ERROR',
  SEND_LOGOUT = 'AUTH/SEND_LOGOUT',
  LOGOUT_SUCCESS = 'AUTH/LOGOUT_SUCCESS',
  LOGOUT_ERROR = 'AUTH/LOGOUT_ERROR',
  SET_IMPERSONATION_ADMIN_EMAIL = 'AUTH/SET_IMPERSONATION_ADMIN_EMAIL',
}

export const initLogin = () => ({
  type: AuthActionType.INIT_LOGIN,
});

export const initCheckCompleted = () => ({
  type: AuthActionType.INIT_CHECK_COMPLETED,
});

export const sendLogin = (
  email: string,
  password: string,
  merchantReference: string,
  merchantGaCookie: string,
  merchantGaSessionIdCookie: string
) => ({
  type: AuthActionType.SEND_LOGIN,
  email,
  password,
  merchantReference,
  merchantGaCookie,
  merchantGaSessionIdCookie,
});

export const sendingLogin = () => ({
  type: AuthActionType.SENDING_LOGIN,
});

export const loginSuccess = (response: any) => ({
  type: AuthActionType.LOGIN_SUCCESS,
  response,
});

export const loginError = (error: any) => ({
  type: AuthActionType.LOGIN_ERROR,
  error,
});

export const loginTwoFactorRequired = (response: any) => ({
  type: AuthActionType.LOGIN_TWO_FACTOR_REQUIRED,
  response,
});

export const sendTwoFactorVerify = (
  email: string,
  password: string,
  code: string,
  merchantReference: string,
  merchantGaCookie: string,
  merchantGaSessionIdCookie: string
) => ({
  type: AuthActionType.SEND_TWO_FACTOR_VERIFY,
  email,
  password,
  code,
  merchantReference,
  merchantGaCookie,
  merchantGaSessionIdCookie,
});

export const twoFactorVerifyError = (error: any) => ({
  type: AuthActionType.TWO_FACTOR_VERIFY_ERROR,
  error,
});

export const refreshToken = (response: any) => ({
  type: AuthActionType.REFRESH_TOKEN,
  response,
});

export const tokenChecked = () => ({
  type: AuthActionType.TOKEN_CHECKED,
});

export const refreshTokenError = (error: any) => ({
  type: AuthActionType.REFRESH_TOKEN_ERROR,
  error,
});

export const sendLogout = () => ({
  type: AuthActionType.SEND_LOGOUT,
});

export const logoutSuccess = (response: any) => ({
  type: AuthActionType.LOGOUT_SUCCESS,
  response,
});

export const logoutError = (error: any) => ({
  type: AuthActionType.LOGOUT_ERROR,
  error,
});

export const setImpersonationAdminEmail = (email?: string) => ({
  type: AuthActionType.SET_IMPERSONATION_ADMIN_EMAIL,
  email,
});
